<template>
  <div class="container py-3">
    <div class="mx-auto mb-3" style="max-width: 640px">
      <h3>填寫基本資料</h3>
      <p>請先填寫以下表單，送出後要記得再次點選『我已填完表單，前往學習中心』按鈕哦</p>
      <button type="submit" class="btn btn-primary"
        @click="completedForm" :disabled="!scollBottom">我已填完表單，前往學習中心</button>
    </div>
    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc32H74JDyGhfANr32noJrgnNP9n56oP_RYNbSw8f5i3CUzpQ/viewform?embedded=true" width="100%" height="1628" frameborder="0" marginheight="0" marginwidth="0">載入中…</iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scollBottom: false,
    };
  },
  methods: {
    completedForm() {
      axios.get('/api/user/completed').then((res) => {
        if (res.status == 200) {
          setTimeout(() => {
            location.reload();
          }, 500);
        }
      });
    },
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    const vm = this;
    window.onscroll = function () {
      if ($(window).scrollTop() + $(window).height() == $(document).height()) {
        vm.scollBottom = true;
      }
    };
  },
  created() {
  },
};
</script>

<style scoped>

</style>
